// @ts-nocheck
import React, { ChangeEvent } from 'react';
import styled from '../../../theme';
import { CalculatorRadioGroup, RadioInput, RadioLabel } from '../styles';
import { DraperyModule } from '../../../redux';
import TrashCan from '../../../assets/icons/trash.svg';
import SearchSelect, { SearchSelectProps } from '../../UI/search_select/search_select';
import Tooltip from '../../UI/tooltip';
import InfoIcon from '../../../assets/icons/info.svg';
import { HeadrailPricingTable } from './headrail-pricing-table';

export const defaultDraperyOrderHeadrail = (): DraperyModule.DraperyOrderHeadrail => {
  return {
    id: 0,
    purchaser: 1,
    receiver: 1,
    supplier: '',
    supplierId: null,
    notes: '',
    otherItems: [
      {
        newItem: true,
        item: '',
        quantity: '',
        description: '',
        finish: '',
      },
      {
        newItem: true,
        item: '',
        quantity: '',
        description: '',
        finish: '',
      },
    ],
    estimateDescription: '',
    quantity: '1',
    cost: '',
    markup: '',
    calculatedPrice: '',
    customerFacingPrice: '',
    headrailSih: {
      description: 'Shipping & Handling for Headrail',
      cost: '',
      markup: '',
      calculatedPrice: '',
      customerFacingPrice: '',
      active: false,
    },
    headrailAdditionalPriceAdjustment: '0',
    headrailAdditionalPriceAdjustmentType: 'none',
  };
};

export const duplicateDraperyOrderHeadrail = (draperyOrderHeadrail: any) => {
  return {
    ...draperyOrderHeadrail,
    id: null,
  };
};

type HeadrailProps = {
  handleInputChangeForNumber(e: ChangeEvent<HTMLInputElement>): void;
  draperyOrderHeadrail: DraperyModule.DraperyOrderHeadrail;
  draperyOrder: DraperyModule.DraperyOrder;
  handleRemovePurchaser(field: 'purchaser' | 'receiver', value: number): void;
  updateHardwareState(e: any, newValue?: boolean, id?: number): void;
  handleSearchSelectChange(
    id: number,
    name: string,
    pathId: string,
    pathName: string,
    itemId?: number,
    search?: string
  ): void;
  handleSearchSelectClear(pathId: string, pathName: string): void;
  onSupplierSearch: SearchSelectProps['onSearch'];
  onAddSupplierByName: SearchSelectProps['onAddByName'];
  openSupplierModalClick(pathId: string, pathName: string): void;
  disabled: boolean;
  handleDeleteTableRow(
    index: number,
    arrayName: string,
    targetKey?: 'draperyOrderHardware' | 'draperyOrderHeadrail'
  ): void;
  onHardwarePricingChange(
    index: number,
    field: 'estimateDescription' | 'cost' | 'quantity' | 'markup' | 'customerPrice',
    value: string,
    isShipping?: boolean
  ): void;
  onToggleHardwareShipping(include: boolean): void;
  orderType: string;
};

const HardwareContainer = styled.div`
  padding-top: 48px;
  display: flex;
  flex-direction: column;
  gap: 48px;
`;

const HeadrailHeader = styled.div`
  display: flex;
  justiy-content: space-between;
  gap: 38px;
  flex-wrap: wrap;
`;

const HeadrailHeaderFirstColumn = styled.div`
  display: flex;
  gap: 10px;
  flex: 1;
  min-width: 375px;
  flex-direction: column;
`;

const HeadrailHeaderColumn = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  flex: 1;
  min-width: 375px;
  flex-direction: column;
`;

const HeadrailHeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  & .label {
    min-width: 120px;

    > span {
      font-weight: 500;
    }
  }

  & .textarea_container {
    flex: 1;

    & .textarea {
      display: flex;
      width: 100%;
      height: 100%;
      outline: none;
      border: 1px solid rgba(35, 35, 35, 0.15);
      border-radius: 8px;
      padding: 10px 8px;
      resize: none;

      &:focus {
        border-color: ${({ theme }) => theme.colors.primary};
      }

      &.disabled {
        opacity: 0.45;
        background-color: white;
      }
    }
  }
`;
const HeadrailTable = styled.table`
  width: 100%;
`;
const HeadrailTableHead = styled.thead`
  border-bottom: 1px solid #e2e2e2;

  & tr {
    & th {
      text-align: left;
      padding: 0px 24px 24px 0px;
    }

    & > :nth-child(1) {
      width: 150px;
    }

    & > :nth-child(2) {
      text-align: center;
      width: 124px;
    }
  }
`;

const HeadrailTableBody = styled.tbody`
  & tr {
    & td {
      text-align: left;
      padding: 12px 24px 12px 0px;

      & input {
        border: 1px solid rgba(35, 35, 35, 0.15);
        border-radius: 8px;
        height: 100%;
        width: 100%;
        outline: none;
        padding: 0px 10px;
        height: 43px;

        &:focus {
          border-color: ${({ theme }) => theme.colors.primary};
        }

        &:disabled {
          background: white;
          opacity: 0.45;
        }
      }
    }

    & > :nth-child(1) {
      width: 150px;
      font-size: 14px;
    }

    & > :nth-child(2) {
      width: 124px;
    }
  }

  & > :nth-child(1) {
    & td {
      padding: 24px 24px 12px 0px;
    }
  }

  & .add_rod_btn {
    height: 40px;
    color: ${({ theme }) => theme.colors.primary};
    font-weight: 500;
    font-size: 16px;

    &.disabled {
      color: #bebebe;
    }
  }
`;

const HeadrailTabRomanShade = (props: HeadrailProps): JSX.Element => {
  const {
    handleInputChangeForNumber,
    draperyOrderHeadrail,
    draperyOrder,
    handleRemovePurchaser,
    updateHardwareState,
    handleSearchSelectChange,
    handleSearchSelectClear,
    onSupplierSearch,
    onAddSupplierByName,
    openSupplierModalClick,
    disabled,
    handleDeleteTableRow,
    onHardwarePricingChange,
    onToggleHardwareShipping,
    orderType
  } = props;

  const purchaserTooltipText = (
    <>
      Headrail will be excluded on the estimate export if <strong>None</strong> is selected for
      Purchaser.
    </>
  );
  const receiverTooltipText = (
    <>
      Headrail will only appear under Components Tracking section if <strong>Workroom</strong> is selected for Purchaser or Receiver. 
    </>
  );
  const isDraperyOrder = orderType === 'drapery-order';
  const isNewRomanShadeOrder = !!draperyOrder.newRomanShade || draperyOrder.id === 0;
  let firstRenderedItemIndex = -1;
  const visibleOtherItems =
    draperyOrderHeadrail.otherItems?.filter(
      (item) => !(isNewRomanShadeOrder && !item.newItem)
    ) || [];
  const canDeleteOtherItems = visibleOtherItems.length > 1;

  const handleEnterPressed = (e: React.KeyboardEvent<HTMLTextAreaElement>): void => {
    const key = e.key;
    if (key === 'Enter' || key === 'Return') {
      e.preventDefault();

      const textarea = e.currentTarget;
      const value = textarea.value;
      const selectionStart = textarea.selectionStart;
      const selectionEnd = textarea.selectionEnd;

      const part1 = value.slice(0, selectionStart);
      const part2 = value.slice(selectionEnd);

      const newValue = part1 + '\n' + part2;

      textarea.value = newValue;
      textarea.selectionStart = textarea.selectionEnd = selectionStart + 1;
    }
  };

  const customerPriceRaw = draperyOrderHeadrail.customerFacingPrice;
  const shippingCustomerPriceRaw = draperyOrderHeadrail.headrailSih?.customerFacingPrice;

  const mainPricingRow = {
    id: 'headrail-main',
    estimateDescription: draperyOrderHeadrail.estimateDescription || '',
    quantity:
      draperyOrderHeadrail.quantity !== undefined && draperyOrderHeadrail.quantity !== null
        ? String(draperyOrderHeadrail.quantity)
        : '1',
    cost:
      draperyOrderHeadrail.cost !== undefined && draperyOrderHeadrail.cost !== null
        ? String(draperyOrderHeadrail.cost)
        : '',
    markup:
      draperyOrderHeadrail.markup !== undefined && draperyOrderHeadrail.markup !== null
        ? String(draperyOrderHeadrail.markup)
        : '',
    customerPrice:
      customerPriceRaw === null
        ? null
        : customerPriceRaw !== undefined
          ? String(customerPriceRaw)
          : '',
  };

  const headrailSih = draperyOrderHeadrail.headrailSih || {};
  const shippingPricingRow = {
    id: 'headrail-shipping',
    estimateDescription: headrailSih.description || 'Shipping & Handling for Headrail',
    quantity: '1',
    cost:
      headrailSih.cost !== undefined && headrailSih.cost !== null
        ? String(headrailSih.cost)
        : '',
    markup:
      headrailSih.markup !== undefined && headrailSih.markup !== null
        ? String(headrailSih.markup)
        : '',
    customerPrice:
      shippingCustomerPriceRaw === null
        ? null
        : shippingCustomerPriceRaw !== undefined
          ? String(shippingCustomerPriceRaw)
          : '',
    active: !!headrailSih.active,
  };

  return (
    <HardwareContainer>
      <HeadrailHeader>
        <HeadrailHeaderFirstColumn>
          <HeadrailHeaderRow>
            <div
              className="label"
              style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: '140px' }}
            >
              <span style={{ fontSize: '16px' }}>Purchaser:</span>
              <Tooltip position="bottom" message={purchaserTooltipText}>
                <InfoIcon style={{ width: '16px', height: '16px' }} />
              </Tooltip>
            </div>

            <CalculatorRadioGroup style={{ paddingLeft: '0px' }}>
              <RadioLabel
                className={`hardware_purchaser ${draperyOrderHeadrail.purchaser === 1 ? 'active' : ''
                  }`}
              >
                <RadioInput
                  type="radio"
                  id="hardware-workroom"
                  name="draperyOrderHeadrail.purchaser"
                  value={1}
                  checked={draperyOrderHeadrail.purchaser === 1}
                  onClick={() => handleRemovePurchaser('purchaser', 1)}
                  onChange={handleInputChangeForNumber}
                  disabled={disabled}
                  uiDisabled={disabled}
                />
                Workroom
              </RadioLabel>

              <RadioLabel
                className={`hardware_purchaser ${draperyOrderHeadrail.purchaser === 2 ? 'active' : ''
                  }`}
              >
                <RadioInput
                  type="radio"
                  id="hardware-client"
                  name="draperyOrderHeadrail.purchaser"
                  value={2}
                  checked={draperyOrderHeadrail.purchaser === 2}
                  onClick={() => handleRemovePurchaser('purchaser', 2)}
                  onChange={handleInputChangeForNumber}
                  disabled={disabled}
                  uiDisabled={disabled}
                />
                Client (COM)
              </RadioLabel>
              <RadioLabel
                className={`hardware_purchaser ${draperyOrderHeadrail.purchaser === 3 ? 'active' : ''
                  }`}
              >
                <RadioInput
                  type="radio"
                  id="hardware-none"
                  name="draperyOrderHeadrail.purchaser"
                  value={3}
                  checked={draperyOrderHeadrail.purchaser === 3}
                  onClick={() => handleRemovePurchaser('purchaser', 3)}
                  onChange={handleInputChangeForNumber}
                  disabled={disabled}
                  uiDisabled={disabled}
                />
                None
              </RadioLabel>
            </CalculatorRadioGroup>
          </HeadrailHeaderRow>


          <HeadrailHeaderRow>
            <div
              className="label"
              style={{ display: 'flex', alignItems: 'center', gap: 6, minWidth: '140px' }}
            >
              <span style={{ fontSize: '16px' }}>Receiver:</span>
              <Tooltip position="bottom" message={receiverTooltipText}>
                <InfoIcon style={{ width: '16px', height: '16px' }} />
              </Tooltip>
            </div>

            <CalculatorRadioGroup style={{ paddingLeft: '0px' }}>
              <RadioLabel
                className={`hardware_purchaser ${draperyOrderHeadrail.receiver === 1 ? 'active' : ''
                  }`}
              >
                <RadioInput
                  type="radio"
                  id="hardware-receiver-workroom"
                  name="draperyOrderHeadrail.receiver"
                  value={1}
                  checked={draperyOrderHeadrail.receiver === 1}
                  onClick={() => handleRemovePurchaser('receiver', 1)}
                  onChange={handleInputChangeForNumber}
                  disabled={disabled}
                  uiDisabled={disabled}
                />
                Workroom
              </RadioLabel>

              <RadioLabel
                className={`hardware_purchaser ${draperyOrderHeadrail.receiver === 2 ? 'active' : ''
                  }`}
              >
                <RadioInput
                  type="radio"
                  id="hardware-receiver-client"
                  name="draperyOrderHeadrail.receiver"
                  value={2}
                  checked={draperyOrderHeadrail.receiver === 2}
                  onClick={() => handleRemovePurchaser('receiver', 2)}
                  onChange={handleInputChangeForNumber}
                  disabled={disabled}
                  uiDisabled={disabled}
                />
                Client (COM)
              </RadioLabel>

              <RadioLabel
                className={`hardware_purchaser ${draperyOrderHeadrail.receiver === 3 ? 'active' : ''
                  }`}
              >
                <RadioInput
                  type="radio"
                  id="hardware-receiver-none"
                  name="draperyOrderHeadrail.receiver"
                  value={3}
                  checked={draperyOrderHeadrail.receiver === 3}
                  onClick={() => handleRemovePurchaser('receiver', 3)}
                  onChange={handleInputChangeForNumber}
                  disabled={disabled}
                  uiDisabled={disabled}
                />
                None
              </RadioLabel>
            </CalculatorRadioGroup>
          </HeadrailHeaderRow>

          <HeadrailHeaderRow>
            <div className="label">
              <span>Supplier</span>
            </div>
            <div className="textarea_container">
              <SearchSelect
                name="draperyOrderHeadrail.supplierId"
                searchType="calculator"
                searchPage="calculator"
                searchItem="supplier"
                placeholder="Please select"
                keepKeyword
                onSearch={onSupplierSearch}
                onAddByName={onAddSupplierByName}
                openModalClick={() =>
                  openSupplierModalClick(
                    'draperyOrderHeadrail.supplierId',
                    'draperyOrderHeadrail.supplier'
                  )
                }
                onItemClick={(id, name) =>
                  handleSearchSelectChange(
                    id,
                    name,
                    'draperyOrderHeadrail.supplierId',
                    'draperyOrderHeadrail.supplier'
                  )
                }
                onKeywordCleared={() =>
                  handleSearchSelectClear(
                    'draperyOrderHeadrail.supplierId',
                    'draperyOrderHeadrail.supplier'
                  )
                }
                initialValue={draperyOrderHeadrail.supplier || ''}
                disabled={disabled}
                addButtonText="Add New Supplier"
              />
            </div>
          </HeadrailHeaderRow>
        </HeadrailHeaderFirstColumn>

        <HeadrailHeaderColumn>
          <HeadrailHeaderRow>
            <div className="label">
              <span>Headrail notes</span>
            </div>
          </HeadrailHeaderRow>

          <HeadrailHeaderRow>
            <div className="textarea_container">
              <textarea
                className={`textarea ${disabled ? 'disabled' : ''}`}
                name="draperyOrderHeadrail.notes"
                value={draperyOrderHeadrail.notes}
                onChange={(e) => updateHardwareState(e)}
                onKeyDown={handleEnterPressed}
                rows={4}
                disabled={disabled}
              />
            </div>
          </HeadrailHeaderRow>
        </HeadrailHeaderColumn>
      </HeadrailHeader>

      <HeadrailPricingTable
        rows={[mainPricingRow]}
        shippingRow={shippingPricingRow}
        includeShipping={!!draperyOrderHeadrail.headrailSih?.active}
        disabled={disabled}
        onChange={onHardwarePricingChange}
        onToggleShipping={onToggleHardwareShipping}
        draperyOrderHeadrail={draperyOrderHeadrail}
      />

      <HeadrailTable>
        <HeadrailTableHead>
          <tr>
            <th>Item</th>
            <th>Qty</th>
            <th>Description</th>
            {!isNewRomanShadeOrder && <th>Finish</th>}
            <th></th>
          </tr>
        </HeadrailTableHead>

        <HeadrailTableBody>
          {draperyOrderHeadrail.otherItems &&
            draperyOrderHeadrail.otherItems.length > 0 &&
            draperyOrderHeadrail.otherItems.map((other, index) => {
              const allItemsNotNew = draperyOrderHeadrail.otherItems.every((item) => !item.newItem);

              if (allItemsNotNew && index === 0 && isNewRomanShadeOrder) {
                const buttonElement = document.querySelector(
                  '#add-other-headrail-item'
                ) as HTMLButtonElement;
                if (buttonElement) {
                  buttonElement.click();
                }
              }

              if (isNewRomanShadeOrder && !other.newItem) {
                return null;
              }

              if (firstRenderedItemIndex < 0) {
                firstRenderedItemIndex = index;
              }

              return (
                <tr key={index}>
                  {other.newItem ? (
                    <td>
                      <input
                        name="draperyOrderHeadrail.otherItems.item"
                        value={other.item}
                        onChange={(e) => updateHardwareState(e, false, index)}
                        disabled={disabled}
                        type="text"
                      />
                    </td>
                  ) : (
                    <td>{other.item}</td>
                  )}
                  <td>
                    <input
                      name="draperyOrderHeadrail.otherItems.quantity"
                      value={other.quantity}
                      onChange={(e) => updateHardwareState(e, false, index)}
                      disabled={disabled}
                      type="text"
                    />
                  </td>
                  <td style={{ paddingRight: isNewRomanShadeOrder ? '0px' : '24px' }}>
                    <input
                      name="draperyOrderHeadrail.otherItems.description"
                      value={other.description}
                      onChange={(e) => updateHardwareState(e, false, index)}
                      disabled={disabled}
                      type="text"
                    />
                  </td>
                  {!isNewRomanShadeOrder && (
                    <td style={{ paddingRight: '0' }}>
                      <input
                        name="draperyOrderHeadrail.otherItems.finish"
                        value={other.finish}
                        onChange={(e) => updateHardwareState(e, false, index)}
                        disabled={disabled}
                        type="text"
                      />
                    </td>
                  )}
                  <td
                    style={{
                      padding: '0',
                      textAlign: 'center',
                      width: '50px',
                      paddingTop:
                        firstRenderedItemIndex === index && isNewRomanShadeOrder ? '12px' : '0px',
                    }}
                  >
                    <button
                      style={{
                        opacity: disabled || !canDeleteOtherItems ? '.4' : '1',
                      }}
                      disabled={disabled || !canDeleteOtherItems}
                      type="button"
                      onClick={() => {
                        if (!disabled && canDeleteOtherItems) {
                          handleDeleteTableRow(index, 'otherItems', 'draperyOrderHeadrail');
                        }
                      }}
                    >
                      <TrashCan
                        style={{
                          width: '25px',
                          height: '25px',
                        }}
                      />
                    </button>
                  </td>
                </tr>
              );
            })}

          <tr>
            <td style={{ textAlign: 'end' }} colSpan={4}>
              <button
                className={`add_rod_btn ${disabled ? 'disabled' : ''}`}
                type="button"
                name="draperyOrderHeadrail.otherItems"
                onClick={(e) => updateHardwareState(e, true)}
                disabled={disabled}
                id="add-other-headrail-item"
                style={{ marginRight: isNewRomanShadeOrder ? '48px' : '0px' }}
              >
                + Add other
              </button>
            </td>
          </tr>
        </HeadrailTableBody>
      </HeadrailTable>
    </HardwareContainer>
  );
};

export default HeadrailTabRomanShade;
